import React, { FC, useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

interface MiniMenuState {
  display: boolean,
  x: number,
  y: number,
  id: number | undefined,
  status: string,
}

interface Props {
  miniMenuState: MiniMenuState,
  closeCallback: VoidFunction,
  updateNameCallback: VoidFunction,
  updateMemberCallback: VoidFunction,
  updateManagerCallback: VoidFunction,
  deleteCallback: VoidFunction,
}

const MiniMenu: FC<Props> = (props) => {
  const { t } = useTranslation()

  const {
    miniMenuState,
    closeCallback,
    updateNameCallback,
    updateMemberCallback,
    updateManagerCallback,
    deleteCallback,
  } = props

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (miniMenuState.display) {
      html.classList.add('modal_open')
    } else {
      html.classList.remove('modal_open')
    }
  }, [miniMenuState.display])

  return (
    <>
      <div className={`mini_menu ${miniMenuState.display || 'none'}`} style={{ top: miniMenuState.y, left: miniMenuState.x }}>
        <ul>
          <li>
            <button
              type="button"
              onClick={() => updateNameCallback()}
            >
              <ReactSVG
                src="/static/images/icon/icon-setting.svg"
                className="icon"
              />
              {t('setting.team.mini_menu.update_name')}
            </button>
          </li>
          <li style={{ color: "inherit" }}>
            <button
              type="button"
              onClick={() => updateManagerCallback()}
            >
              <ReactSVG
                src="/static/images/icon/icon-info.svg"
                className="icon"
              />
              {t('setting.team.mini_menu.update_manager')}
            </button>
          </li>
          <li style={{ color: "inherit" }}>
            <button
              type="button"
              onClick={() => updateMemberCallback()}
            >
              <ReactSVG
                src="/static/images/icon/icon-info.svg"
                className="icon"
              />
              {t('setting.team.mini_menu.update_member')}
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => deleteCallback()}
            >
              <ReactSVG
                src="/static/images/icon/icon-trash.svg"
                className="icon"
              />
              {t('form.component.delete')}
            </button>
          </li>
        </ul>
      </div>
      <div className={`close_screen gray ${miniMenuState.display || 'none'}`} role="presentation" onClick={closeCallback} />
    </>
  )
}

export default MiniMenu
